import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";

export default class JoiningbonusDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
    };
  }
  componentDidMount() {
    console.log(this.props);
    if (this.props.location.state) {
      this.GetTransactions(this.props.location.state.cdate);
    } else {
      this.props.history.goBack();
    }
  }
  async GetTransactions(cdate) {
    let res = await ApiRequest(
      "GetJoiningBonusDetails.asp",
      "POST",
      { cdate: cdate },
      { Authorization: localStorage.getItem("token") }
    );
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items,
    });
  }
  //
  render() {
    return (
      <div>
        <PageHeader title="Affiliate Bonus Report" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3
                  className="card-title text-color-1"
                  style={{ fontWeight: "200", fontSize: "22px" }}
                >
                  Affiliate Bonus Report
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                    style={{ textAlign: "center" }}
                  >
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        <th>Pair Match</th>
                        <th>Pair</th>
                        <th>Payout</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.tableData.length <= 0 ? (
                        <tr>
                          <td colSpan="5">No Details Found</td>
                        </tr>
                      ) : (
                        this.state.tableData.map((item, index) => (
                          <tr key={index}>
                            <td className="tabletd">{index + 1}</td>
                            <td>{item.payoutdate}</td>
                            <td>{item.pair_match}</td>
                            <td>{item.paid_pair}</td>
                            <td>{item.payout}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
